import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { StyledAiMenuComponent } from "./ai-menu-component.scss";
import DescriptiveLinkBlock from "../components/descriptive-link-block/descriptive-link-block";
import MiniLinkItem from "../components/mini-link-item/mini-link-item";
import MenuDivider from "../components/menu-divider/menu-divider";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import { AI_PLATFORM_CAPABILITY_GROUPS, AI_PLATFORM_CREATE_SOLUTION, AI_PLATFORM_USE_CASE_LINKS, WIDE_AI_MENU_LOCALE_IDS } from "./ai-platform-menu-data";
import { MondayLogoIcon } from "./icons/index.js";
import { createLocalizeLink } from "../index.js";
const AiMenuComponent = ({ translate, menuId, onLinkClick, headerCatalogLinks, localeId })=>{
    const onLinkClickWithMenuId = (event, link, text)=>onLinkClick({
            menuId,
            link,
            event,
            text
        });
    const localizeLink = createLocalizeLink(headerCatalogLinks);
    const localizedCreate = localizeLink(AI_PLATFORM_CREATE_SOLUTION);
    const capabilityColumns = [
        1,
        2,
        3
    ].map((col)=>AI_PLATFORM_CAPABILITY_GROUPS.filter((g)=>g.column === col));
    const isWideLocale = WIDE_AI_MENU_LOCALE_IDS.includes(localeId);
    return /*#__PURE__*/ _jsxs(StyledAiMenuComponent, {
        className: classnames("menu-component", "ai-platform-menu", {
            "is-wide-locale": isWideLocale
        }),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "ai-platform-left",
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: "menu-section-title align-to-link",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "monday-logo-icon",
                                children: /*#__PURE__*/ _jsx(MondayLogoIcon, {})
                            }),
                            translate("header.tabs.aiPlatform.left.title")
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "menu-section-subtitle",
                        children: translate("header.tabs.aiPlatform.left.subtitle")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "use-case-grid",
                        children: AI_PLATFORM_USE_CASE_LINKS.map(({ iconUrl, titleKey, descriptionKey, link }, index)=>{
                            const localized = localizeLink({
                                link
                            });
                            return /*#__PURE__*/ _jsx(DescriptiveLinkBlock, {
                                iconUrl: iconUrl,
                                title: translate(titleKey),
                                description: translate(descriptionKey),
                                link: localized.link,
                                onClick: (event)=>onLinkClickWithMenuId(event, localized.link, titleKey)
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "create-own-solution-link",
                        children: /*#__PURE__*/ _jsx(SecondaryButton, {
                            buttonText: translate(AI_PLATFORM_CREATE_SOLUTION.textKey),
                            url: localizedCreate.link,
                            isWithArrow: true,
                            color: "black",
                            onClick: (event)=>onLinkClickWithMenuId(event, localizedCreate.link, AI_PLATFORM_CREATE_SOLUTION.textKey)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MenuDivider, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "ai-platform-right",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "capabilities-main-title",
                        children: translate("header.tabs.aiPlatform.capabilities.title")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "capabilities-columns",
                        children: capabilityColumns.map((groups, colIndex)=>/*#__PURE__*/ _jsx("div", {
                                className: "capabilities-column",
                                children: groups.map((group, groupIndex)=>/*#__PURE__*/ _jsxs("div", {
                                        className: "capability-group",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "capability-group-title",
                                                children: translate(group.headingKey)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "capability-links",
                                                children: group.links.map(({ Icon, textKey, link: rawLink }, linkIndex)=>{
                                                    const { link } = localizeLink({
                                                        link: rawLink
                                                    });
                                                    return /*#__PURE__*/ _jsx(MiniLinkItem, {
                                                        Icon: Icon,
                                                        text: translate(textKey),
                                                        link: link,
                                                        onClick: (event)=>onLinkClickWithMenuId(event, link, textKey)
                                                    }, linkIndex);
                                                })
                                            })
                                        ]
                                    }, `${group.headingKey}-${groupIndex}`))
                            }, colIndex))
                    })
                ]
            })
        ]
    });
};
export default AiMenuComponent;
